export default __webpack_public_path__ + "static/media/6.c9e66102.png";